import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { COURSE_TYPE_NODE_FRAGMENT } from '../fragments'

const REVERT_REPLACE_COURSE_TYPE_MUTATION = gql`
  mutation revertReplaceCourseType($replaceToken: String!) {
    revertReplaceCourseType(replaceToken: $replaceToken) {
      results {
        ...CourseTypeNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${COURSE_TYPE_NODE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default REVERT_REPLACE_COURSE_TYPE_MUTATION
